import { Tooltip } from 'uiv';
import '../bootstrap/tooltip.scss';
import '../bootstrap/component-animations.scss';
import './tooltip-red.scss';

export default Tooltip;
